import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppTopBar, formatIDR } from "@/components/AppTopBar";

const LABELS = {
  PURCHASE: "Purchase",
  DIRECT_PAYMENT: "Pembayaran Langsung",
  DIRECT_PAYMENT_REVERSAL: "Reversal Pembayaran",
  DEPOSIT_IN: "Deposit Masuk",
  DEPOSIT_APPLIED: "Deposit Dipakai",
  DEPOSIT_APPLIED_REVERSAL: "Reversal Allocation",
  DEPOSIT_REFUND: "Refund Deposit",
  DEPOSIT_REFUND_REVERSAL: "Reversal Refund",
};

function fmtDate(v) {
  if (!v) return "-";
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? v : d.toLocaleString("id-ID");
}

export default function SupplierLedger() {
  const { id } = useParams();
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/suppliers/${id}/ledger`)
      .then(({ data: body }) => setData(body))
      .catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail) || err.message));
  }, [id]);

  if (user && user.role !== "OWNER") {
    return <div className="app-shell"><AppTopBar active="suppliers" /><main className="content"><div className="alert-error">Akses ditolak.</div></main></div>;
  }

  return (
    <div className="app-shell">
      <AppTopBar active="suppliers" />
      <main className="content">
        <Link to="/suppliers" className="back-link">← Kembali ke Master Supplier</Link>
        {error && <div className="alert-error">{error}</div>}

        {data && (
          <>
            <section className="panel">
              <div className="panel-head">
                <div>
                  <h2 className="panel-title">Supplier Ledger — {data.supplier.name}</h2>
                  <div className="hint">{data.supplier.supplier_code} · {data.supplier.status}</div>
                </div>
              </div>
              <div className="meta-grid">
                <div><span className="meta-label">Purchase</span><span className="mono">{data.summary.purchase_count}</span></div>
                <div><span className="meta-label">Nilai Purchase Finansial</span><span className="mono">{formatIDR(data.summary.financial_purchase_total)}</span></div>
                <div><span className="meta-label">Direct Payment</span><span className="mono">{formatIDR(data.summary.direct_paid)}</span></div>
                <div><span className="meta-label">Deposit Terpakai</span><span className="mono">{formatIDR(data.summary.deposit_allocated)}</span></div>
                <div><span className="meta-label">Total Settled</span><span className="mono">{formatIDR(data.summary.total_settled)}</span></div>
                <div><span className="meta-label">Outstanding Purchase</span><span className="mono">{formatIDR(data.summary.purchase_outstanding)}</span></div>
                <div><span className="meta-label">Total Deposit</span><span className="mono">{formatIDR(data.summary.total_deposited)}</span></div>
                <div><span className="meta-label">Refund Deposit</span><span className="mono">{formatIDR(data.summary.deposit_refunded)}</span></div>
                <div><span className="meta-label">Saldo Deposit Tersedia</span><span className="mono">{formatIDR(data.summary.deposit_available)}</span></div>
              </div>
            </section>

            <section className="panel">
              <h2 className="panel-title">Riwayat Transaksi Supplier</h2>
              <p className="hint">Purchase DRAFT tetap terlihat untuk audit, tetapi tidak dihitung sebagai kewajiban finansial sampai OPEN.</p>
              <div className="table-scroll">
                <table className="data-table">
                  <thead><tr><th>Waktu</th><th>Jenis</th><th>Referensi</th><th>Nominal</th><th>Account</th><th>Status</th><th>Catatan</th></tr></thead>
                  <tbody>
                    {data.events.length === 0 && <tr><td colSpan={7} className="empty-cell">Belum ada transaksi Supplier.</td></tr>}
                    {data.events.map((e, idx) => (
                      <tr key={`${e.type}-${e.at}-${idx}`}>
                        <td>{fmtDate(e.at)}</td>
                        <td>{LABELS[e.type] || e.type}</td>
                        <td className="mono">{e.reference || e.purchase_no || "-"}</td>
                        <td className="mono">{formatIDR(e.amount)}</td>
                        <td>{e.account_name || "-"}</td>
                        <td><span className={`status-pill ${e.status === "POSTED" || e.status === "OPEN" ? "on" : "off"}`}>{e.status || "-"}</span></td>
                        <td>{e.note || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </>
        )}
      </main>
    </div>
  );
}
